var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoMarket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.2625C0 19.7909 0 19.055 0.197406 18.3774C0.372271 17.7771 0.659642 17.2125 1.04541 16.7114C1.4809 16.1456 2.08539 15.6939 3.29437 14.7903L21.3805 1.27386C22.3174 0.5737 22.7858 0.223622 23.3031 0.089053C23.7595 -0.0296843 24.2405 -0.0296843 24.6969 0.089053C25.2142 0.223622 25.6826 0.573701 26.6195 1.27386L44.7056 14.7903C45.9146 15.6939 46.5191 16.1456 46.9546 16.7114C47.3404 17.2125 47.6277 17.7771 47.8026 18.3774C48 19.055 48 19.7909 48 21.2625V39.8006C48 42.6707 48 44.1057 47.4187 45.2019C46.9074 46.1662 46.0915 46.9501 45.088 47.4415C43.9471 48 42.4536 48 39.4667 48H8.53333C5.54639 48 4.05291 48 2.91205 47.4415C1.90852 46.9501 1.09262 46.1662 0.581299 45.2019C0 44.1057 0 42.6707 0 39.8006V21.2625Z",
    fill: "#DCEFE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6868 34.3501H16.3868V24.3709H15.458V18.9805H32.5412V24.3709H31.6868V34.3501ZM16.8668 33.8701H31.2044V23.8909H32.0588V19.4605H15.938V23.8909H16.8668V33.8701Z",
    fill: "#004C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3955 23.875V33.343H30.6795V23.875H17.3955ZM26.9403 27.4126H21.0603V25.9198H26.9403V27.4126Z",
    fill: "#004C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4658 19.9863V23.3631H17.3034H30.7698H31.533V19.9863H16.4658Z",
    fill: "#091E0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoMarket);
export default __webpack_public_path__ + "static/media/OneoMarket.1341257845b9f60f72ad310cf8c7f399.svg";
export { ForwardRef as ReactComponent };